
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";


/************************************  ALERTS & RECOMMENDATIONS  ************************************/
export const AlertsRecommendations = () => {
  const items = [
    { message: "Cart-abandonment rate increased by 12%", type: "alert" },
    { message: "Consider launching a mid-month flash sale", type: "recommendation" },
  ];

  const bg     = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");

  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>
        Alerts&nbsp;&amp;&nbsp;Recommendations
      </Heading>

      <VStack align="stretch" spacing={3}>
        {items.map((item, idx) => (
          <HStack key={idx} spacing={3}>
            <Badge colorScheme={item.type === "alert" ? "red" : "purple"} textTransform="capitalize">
              {item.type}
            </Badge>
            <Text>{item.message}</Text>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};
